import { useQuery, useMutation, useQueryClient, keepPreviousData } from '@tanstack/react-query';
import { api } from '@/lib/api';

export type ExternalTraining = {
  id: number;
  user_id: number;
  title: string;
  institution: string;
  description: string | null;
  file_url: string | null;
  file_name: string | null;
  completed_at: string;
  created_at: string;
};

export type CreateExternalTrainingInput = {
  title: string;
  institution?: string;
  description?: string;
  file_url?: string;
  file_name?: string;
  completed_at?: string;
};

const KEYS = {
  all: ['external-trainings'] as const,
  mine: (page: number, positionId?: number) => [...KEYS.all, 'mine', page, positionId] as const,
};

export function useMyExternalTrainings(page = 1, positionId?: number) {
  return useQuery({
    queryKey: KEYS.mine(page, positionId),
    queryFn: () =>
      api.get<ExternalTraining[]>('/external-trainings/mine', {
        page: String(page),
        per_page: '20',
        position_id: positionId ? String(positionId) : undefined,
      }),
    placeholderData: keepPreviousData,
  });
}

export function useCreateExternalTraining() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: CreateExternalTrainingInput) =>
      api.post<ExternalTraining>('/external-trainings', data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: KEYS.all });
    },
  });
}

export function useDeleteExternalTraining() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => api.delete(`/external-trainings/${id}`),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: KEYS.all });
    },
  });
}
